import React, { useEffect, useRef, useState } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
// import Geocode from "react-geocode";
// import { geocode } from "react-geocode";
// import { Geocode } from "react-geocode";

import { useFormik } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import ErrorText from "../common/ErrorText";
import styles from "../../Styles/modal.module.css";
import apiCall from "../../helpers/apifactory";
// import DatePicker from "react-date-picker";
import DatePicker from "react-datepicker";
// import { geocode } from "react-geocode";
import moment from "moment";
import Select from "react-select";
import Geocode from "react-geocode";
import "react-datepicker/dist/react-datepicker.css";
// import { Checkbox, FormControlLabel } from "@mui/material";
// import { red } from "@mui/material/colors";

const apiKey = "AIzaSyA60gAFM1MOpyBF30dymn-_F3sOanHcGGs";

const PickupRequest = () => {
  const modalRef = useRef(null);
  const modalMapRef = useRef(null);
  // const [isChecked, setIsChecked] = useState(false);
  const [fare, setFare] = useState(0);
  // const [destState, setDestState] = useState("");
  // const [weightState, setWeightState] = useState("");
  const [responseID, setResponseID] = useState("");
  const [newcities, setNewCities] = useState([]);
  // const [originState, setOriginState] = useState("");
  // const [isFCValid, setFromCityIsValid] = useState(true);
  // const [isTCValid, setToCityIsValid] = useState(true);
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
  const [show, setShow] = useState(false);
  const [isShowMap, setShowMap] = useState("");
  // const [apiKey, setApiKey] = useState(
  //   "AIzaSyA60gAFM1MOpyBF30dymn-_F3sOanHcGGs"
  // );

  // const handleCheckIns = (event) => {
  //   const tempCheck = !isChecked;
  //   setIsChecked(tempCheck);
  //   if (!tempCheck) setInsVal(0);
  // };

  // const handleChange = (e) => {
  //   setOriginState(e.value);
  // };
  // const handleChangeDestinate = (e) => {
  //   setDestState(e.value);
  // };

  const consingnmentType = [
    { id: "1", Description: "Document" },
    { id: "2", Description: "Parcel" },
  ];

  useEffect(() => {
    if (show) {
      modalRef.current.classList.add(styles.visible);
    } else {
      modalRef.current.classList.remove(styles.visible);
    }
  }, [show]);
  useEffect(() => {
    if (isShowMap !== "") {
      modalMapRef.current.classList.add(styles.visible);
    } else {
      modalMapRef.current.classList.remove(styles.visible);
    }
  }, [isShowMap]);
  const formik = useFormik({
    initialValues: {
      shipMobNum: "",
      shipEmail: "",
      shipName: "",
      conType: "",
      serType: "",
      pickDate: "",
      pickTime: moment(new Date()).format("HH:mm"),
      weight: "0.0",
      quantity: "",
      originState: undefined,
      destState: undefined,
      shipAddress: "",
      shipBlockPhase: "",
      shipLandMark: "",
      instruction: "",
      name: "",
      consMobNum: "",
      consEmail: "",
      shipArea: "",
      address: "",
      consLandMark: "",
      recaptcha: "",
      declaredvalue: "",
    },

    validationSchema: Yup.object({
      shipMobNum: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      shipEmail: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
      shipName: Yup.string().required("This is Required"),
      conType: Yup.string().required("This is Required"),
      serType: Yup.string().required("This is Required"),
      pickDate: Yup.string().required("This is Required"),
      pickTime: Yup.string().required("This is Required"),
      weight: Yup.number().required("This is Required"),
      quantity: Yup.string().required("This is Required"),
      shipAddress: Yup.string().required("This is Required"),
      shipLandMark: Yup.string().required("This is Required"),
      instruction: Yup.string().required("This is Required"),
      name: Yup.string().required("This is Required"),
      consMobNum: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      consEmail: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
      address: Yup.string().required("This is Required"),
      consLandMark: Yup.string(),
      declaredvalue: Yup.string(),
      recaptcha: Yup.string().required(),
      originState: Yup.object()?.required("This is Required"),
      destState: Yup.object()?.required("This is Required"),
    }),
    onSubmit: (values) => {
      // setFromCityIsValid(originState ? true : false);
      // setToCityIsValid(destState ? true : false);
      // var NewDate = moment(values?.pickDate, "DD-MM-YYYY").format();
      // NewDate = NewDate.split("T")[0];
      // function addZero(i) {
      //   if (i < 10) {
      //     i = "0" + i;
      //   }
      //   return i;
      // }

      // var today = new Date(),
      //   time = today.getHours() + ":" + addZero(today.getMinutes());

      // console.log("values?.pickTime < time", values?.pickTime < time);
      // if (values?.pickTime < time) {
      //   return;
      // }
      // if (originState === "") {
      //   setFromCityIsValid(originState ? true : false);
      //   return;
      // }
      // if (destState === "") {
      //   setToCityIsValid(destState ? true : false);
      //   return;
      // }

      const body = {
        clsInsertData: [
          {
            MOBILE_NO: values?.shipMobNum,
            EMAIL: values?.shipEmail,
            SHIPPER_NAME: values?.shipName,
            CONSIGNMENT_TYPE: values?.conType === "Document" ? "n" : "o",
            services: values?.serType,
            PICKUP_TIME: values?.pickTime,
            PICKUP_DATE: moment(values?.pickDate).format("DD-MM-YYYY"),
            WEIGHT: values?.weight,
            QTY: values?.quantity,
            FROM_City: values?.originState,
            TO_City: values?.destState,
            ADDRESS:
              values?.shipAddress.length <= 120
                ? values?.shipAddress
                : values?.shipAddress.slice(0, 120),
            NEAREST_LANDMARK: values?.shipLandMark,
            SPECIAL_INSTRUCTION: values?.instruction,
            CONSIGNEE_NAME: values?.name,
            CONSIGNEE_MOBILE: values?.consMobNum,
            CONSIGNEE_EMAIL: values?.consEmail,
            CONSIGNEE_ADDRESS:
              values?.address.length <= 120
                ? values?.address
                : values?.address.slice(0, 120),
            CONSIGNEE_LANDMARK: values?.consLandMark,
            HOUSE_NUMBER: values?.shipBlockPhase,
            DECLARED_VALUE: values?.declaredvalue,
          },
        ],
      };
      apiCall
        .insertPickup(body, {})
        .then((res) => {
          setResponseID(res?.data?.responseData?.p_pickup_id);
          setShow(true);
          formik.setValues(formik?.initialValues);

          formik.setTouched({}, false);
          setFare(0);
        })
        .catch((error) => {
          console.log("===============", error);
        });
    },
  });
  useEffect(() => {
    const { weight, originState, destState } = formik?.values;
    if (weight && originState && destState) {
      const body = {
        // origincode: originState.split("-")[0],
        // destinationcode: destState.split("-")[0],
        origincode: originState?.value,
        destinationcode: destState?.value,
        weight: weight,
      };
      apiCall
        .getTarif(body, {})
        .then((res) => {
          setFare(res?.data?.responseData?.data[0].totalamount);
        })
        .catch((error) => {
          // console.log("===============", error);
        });
    }
    // }, [originState, destState, weightState, formik?.values]);
  }, [formik?.values]);

  useEffect(() => {
    apiCall
      .getCity()
      .then((res) => {
        var cityarr = res?.data?.responseData?.cities.map(
          ({ station_code, station_name }) => ({
            value: station_code,
            label: station_name,
          })
        );
        setNewCities(cityarr);
      })
      .catch((error) => {
        // console.log("===============", error);
      });
  }, []);

  // useEffect(() => {
  //   apiCall
  //     .getServices()
  //     .then((res) => {
  //       console.log(
  //         "00000",
  //         res?.data?.responseData?.servicedata?.service_description
  //       );
  //       setServiceTypeOptions(res?.data?.responseData?.servicedata?.service_description);
  //     })
  //     .catch((error) => {
  //       console.log("===============", error);
  //     });
  // }, []);

  useEffect(() => {
    apiCall
      .getServices()
      .then((res) => {
        const servicearr = res?.data?.responseData?.servicedata.map((each) => ({
          ...each,
          consignmentType: each?.servicetypeid === 1 ? "Document" : "Parcel",
          value: each?.service_code,
          label: each?.service_description,
        }));
        setServiceTypeOptions(servicearr);
      })
      .catch((error) => {
        // console.log("===============", error);
      });
  }, []);

  //useEffect(() => {
  //    apiCall?.getServices()?.then((res) => {
  //        setServiceTypeOptions(res?.data?.services);
  //    });
  //}, []);

  const center = {
    lat: 24.89496195,
    lng: 67.15677305,
  };

  const [position, setPosition] = useState(center);
  // const [zoom, setZoom] = useState(12);
  // useEffect(() => {
  //   setZoom(zoom);
  // }, [zoom]);

  // useEffect(
  //   () =>
  //     navigator?.geolocation?.getCurrentPosition((e) =>
  //       console.log("=======>", e)
  //     ),
  //   []
  // );

  const [address, setAddress] = useState("");

  useEffect(() => {
    // Initialize Geocode
    Geocode.setApiKey(apiKey);
    console.log(Geocode);
    // Reverse geocoding using lat/lng
    Geocode.fromLatLng(position.lat, position.lng)

      .then((response) => {
        const address = response.results[0].formatted_address;
        setAddress(address);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [position, apiKey]);

  const [locationArr, setLocationArr] = useState([]);
  const [insVal, setInsVal] = useState(0);

  const checkTIme = (time) => {
    // console.log("formik?.values?.pickDate", formik?.values?.pickDate);
    return (
      new Date().getHours() < time ||
      new Date()?.getDate() < new Date(formik?.values?.pickDate)?.getDate()
    );
  };

  const [dateState, setDateState] = useState(new Date());

  useEffect(() => {
    new Date().getHours() >= 17
      ? setDateState(new Date(new Date().setDate(new Date().getDate() + 1)))
      : setDateState(new Date());
  }, []);

  useEffect(() => {
    formik?.setFieldValue("pickDate", dateState);
  }, [dateState]);

  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("a").classNameList?.add("fixed-header-desktop")
        : document
            .querySelector("a")
            .classNameList?.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList?.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList?.remove("fixed-header-desktop");
    },
    false
  );

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="text-[30px] sm:text-[40px] font-bold">
          Schedule A Pickup
        </h1>
      </div>

      <div className="mt-[3rem]">
        <div className="flex flex-col justify-center mt-[1rem] ">
          <div className="flex  sm:mx-[auto]  flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500 mb-0">
            <h2 className="font-bold text-[1.1rem]">Request for pickup form</h2>
            <div className="flex gap-4 mt-4">
              <div className="flex-1 flex flex-col gap-1">
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="shipMobNum"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="shipMobNum"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.shipMobNum}
                        maxLength="11"
                      />
                      <label
                        htmlFor="shipMobNum"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Mobile Number *
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.shipMobNum &&
                        formik?.errors?.shipMobNum
                      }
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="shipEmail"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="shipEmail"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.shipEmail}
                      />
                      <label
                        htmlFor="shipEmail"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Email *
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.shipEmail && formik?.errors?.shipEmail
                      }
                    />
                  </div>
                </div>
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="shipName"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="shipName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.shipName}
                        maxLength={60}
                      />
                      <label
                        htmlFor="shipName"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Shipper Name *
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.shipName && formik?.errors?.shipName
                      }
                    />
                  </div>
                </div>
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <select
                        id="conType"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="conType"
                        onChange={(e) => {
                          formik.handleChange(e);
                          // setSelectedCOnsign(e?.target?.value);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.conType}
                      >
                        <option>Please Select</option>

                        {consingnmentType?.map((each, index) => (
                          <option key={index}>{each?.Description}</option>
                        ))}
                      </select>
                      <label
                        htmlFor="conType"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Consignment Type *
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.conType && formik?.errors?.conType}
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <select
                        id="serType"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="serType"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.serType}
                      >
                        <option>Please Select</option>
                        {serviceTypeOptions?.map(
                          (each, index) =>
                            each?.consignmentType ===
                              formik?.values?.conType && (
                              <option key={index}>
                                {each?.service_description}
                              </option>
                            )
                        )}
                      </select>
                      <label
                        htmlFor="serType"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Service Type *
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.serType && formik?.errors?.serType}
                    />
                  </div>
                </div>

                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="weight"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="weight"
                        min={0}
                        onChange={(e) => {
                          formik.handleChange(e);
                          // setWeightState(e?.target?.value);
                        }}
                        onBlur={(e) => {
                          formik.handleBlur(e);
                          // setWeightState(e?.target?.value);
                        }}
                        value={formik.values.weight}
                      />
                      <label
                        htmlFor="weight"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Weight (kg)*
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.weight && formik?.errors?.weight}
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <select
                        id="quantity"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="quantity"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.quantity}
                      >
                        <option className="selected-option">
                          Please Select
                        </option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                      </select>
                      <label
                        htmlFor="quantity"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Pieces*
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.quantity && formik?.errors?.quantity
                      }
                    />
                  </div>
                </div>

                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative grid ">
                      <DatePicker
                        id="pickDate"
                        className="calendar block px-2.5 h-[2.4rem] w-full text-sm text-light bg-transparent rounded border border-gray-500 focus:border-red hover:border-black"
                        name="pickDate"
                        onChange={(e) => formik?.setFieldValue("pickDate", e)}
                        // selected={new Date()}
                        selected={formik.values.pickDate} // Use Formik value for selection
                        // onChange={date => setStartDate(date)}
                        onBlur={formik.handleBlur}
                        value={formik.values.pickDate}
                        placeholderText="--/--/----"
                        maxDate={
                          new Date(
                            new Date(dateState)?.setDate(
                              new Date(dateState)?.getDate() +
                                (new Date(dateState)?.getDay() > 3 ? 4 : 3)
                            )
                          )
                        }
                        minDate={new Date(dateState)}
                        tileDisabled={({ date }) => date.getDay() === 0}
                      />
                      <label
                        htmlFor="pickDate"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Pickup Date *
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.pickDate && formik?.errors?.pickDate
                      }
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative flex">
                      <select
                        id="pickTime"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="pickTime"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pickTime}
                      >
                        <option className="selected-option">
                          Please Select
                        </option>

                        {checkTIme(11) && <option>11:00 AM to 1:00 PM</option>}
                        {checkTIme(13) && <option>1:00 PM to 3:00 PM</option>}
                        {checkTIme(15) && <option>3:00 PM to 5:00 PM</option>}
                        {checkTIme(17) && <option>5:00 PM to 8:00 PM</option>}
                      </select>
                      <label
                        htmlFor="pickTime"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Pickup Time *
                      </label>
                      {/* <input
                        type="time"
                        id="time"
                        className="laptopTime block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="pickTime"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pickTime}
                        mintime={new Date().getTime()}
                        
                      /> */}

                      {/* <input
                        type="text"
                        id="time"
                        className="sm:flex hidden mobileTime block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="pickTime"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pickTime}
                        onFocus={() => {
                          document.getElementById("time").type = "time";
                        }}
                      />
                      <label
                        htmlFor="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Pickup Time *
                      </label> */}
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.pickTime && formik?.errors?.pickTime
                      }
                    />
                  </div>
                </div>

                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1 sm:w-[48%]">
                    <div className="relative">
                      <Select
                        className="select1"
                        placeholder="Origin (city)"
                        name="originState"
                        id="originState"
                        value={formik?.values?.originState}
                        options={newcities}
                        onChange={(e) => {
                          formik?.setFieldValue("originState", e);
                        }}
                        onBlur={(e) => {
                          formik?.setFieldTouched("originState", true);
                        }}
                      />
                      {/* <select
                        id="originState"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder="Origin (city)"
                        name="originState"
                        value={formik?.values?.city}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {newcities?.map((data, index) => {
                          return (
                            <option key={index} value={data?.value}>
                              {data?.label}
                            </option>
                          );
                        })}
                      </select> */}
                      <ErrorText
                        text={
                          formik?.touched?.originState &&
                          formik?.errors?.originState
                        }
                      />
                    </div>
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <Select
                        className="select1"
                        placeholder="Destination (city)"
                        name="destState"
                        id="destState"
                        value={formik?.values?.destState}
                        options={newcities}
                        onChange={(e) => {
                          formik?.setFieldValue("destState", e);
                        }}
                        onBlur={(e) => {
                          formik?.setFieldTouched("destState", true);
                        }}
                      />
                      {/* <select
                        id="destState"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder="Origin (city)"
                        name="destState"
                        value={formik?.values?.city}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        {newcities?.map((data, index) => {
                          return (
                            <option key={index} value={data?.value}>
                              {data?.label}
                            </option>
                          );
                        })}
                      </select> */}
                      <ErrorText
                        text={
                          formik?.touched?.destState &&
                          formik?.errors?.destState
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="MuiFormControl-root flex-1">
                    <div className="flex items-center">
                      <div className="relative flex-1">
                        <input
                          type="text"
                          id="shipAddress"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                          name="shipAddress"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.shipAddress}
                          maxLength={120}
                        />

                        <label
                          htmlFor="shipAddress"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Shipper Address *
                        </label>
                      </div>
                      <div
                        className="MuiFormControl-root MuiTextField-root ml-1 cursor-pointer"
                        onClick={() => setShowMap("shipAdd")}
                      >
                        <img
                          src="/location.svg"
                          alt=""
                          className="w-[30px] h-[30px] "
                        />
                      </div>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.shipAddress &&
                        formik?.errors?.shipAddress
                      }
                    />
                  </div>
                </div>

                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="shipLandMark"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="shipLandMark"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.shipLandMark}
                        maxLength={30}
                      />

                      <label
                        htmlFor="shipLandMark"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Nearest Landmark
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.shipLandMark &&
                        formik?.errors?.shipLandMark
                      }
                    />
                  </div>

                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="instruction"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="instruction"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.instruction}
                      />
                      <label
                        htmlFor="instruction"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Special Instruction
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.instruction &&
                        formik?.errors?.instruction
                      }
                    />
                  </div>
                </div>

                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="shipBlockPhase"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="shipBlockPhase"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.shipBlockPhase}
                      />

                      <label
                        htmlFor="shipBlockPhase"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Building/House No.
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.shipBlockPhase &&
                        formik?.errors?.shipBlockPhase
                      }
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="shipArea"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="shipArea"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.shipArea}
                      />
                      <label
                        htmlFor="shipArea"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Area
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.shipArea && formik?.errors?.shipArea
                      }
                    />
                  </div>
                </div>

                {/* DONOT REMOVE THIS COMMENT CODE FOR FUTURE USE */}

                {/* <div className="flex gap-4 ">
                  <div className="flex items-center w-[49%]">
                    <FormControlLabel
                      onClick={handleCheckIns}
                      control={
                        <Checkbox
                          sx={{
                            "&.Mui-checked": { color: red[600] },
                          }}
                        />
                      }
                      label={<p className="text-sm">Insurance Required</p>}
                    />
                  </div>

                  {isChecked === true && (
                    <div className="MuiFormControl-root flex-1 w-[49%]">
                      <div className="relative">
                        <input
                          type="number"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder="0"
                          name="declaredvalue"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.declaredvalue}
                        />

                        <label
                          htmlFor="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Declared Value
                        </label>
                      </div>
                    </div>
                  )}
                </div> */}

                <div className="sm:flex flex gap-4">
                  {/* <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                    <select
                          
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          // value={age}
                          // onChange={handleChange}
                          label="Time"
                        >
                          {dayTime.map((product, index) => (
                             <MenuItem key={index} value={product.id} onClick={() =>
                              setSelectedTime(product.id)
                            // setCookie('prodType', product, { path: '/' })
                            }>
                              {product.value}
                            </MenuItem>
  
                            // <MenuItem key={index} value={product} onClick={() => setSelectedSubCategory(product)}>
                            // <MenuItem key={index} value={product} onClick={() => setCookie('subCat', product, { path: '/' })}>
                            //   {product}
                            // </MenuItem>
                          ))}
                        </select>
                        <label
                        htmlFor="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        faisal bhai*
                      </label>
                      <select
                        id="floating_outline"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="quantity"
                       
                      >
                        <option>Please Select</option>
                       
                      </select>
                      <label
                        htmlFor="floating_outlined"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        End Time*
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.quantity && formik?.errors?.quantity}
                    />
                  </div> */}
                </div>
              </div>
            </div>
            <h2 className="font-bold flex justify-end">{`Total Fare: ${
              Number(fare) + (fare > 0 ? (Number(insVal) / 100) * 2 : 0)
            }`}</h2>
          </div>
        </div>
      </div>
      <div className="my-[1rem]">
        <div className="flex flex-col justify-center mt-[1rem] ">
          <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] sm:mx-[auto] mx-[1rem] rounded-md transition-all duration-500 mb-0">
            <h2 className="font-bold text-[1.1rem]">Consignee Information</h2>
            <div className="flex gap-4 mt-4">
              <div className="flex-1 flex flex-col gap-1">
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="name"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                        maxLength={60}
                      />
                      <label
                        htmlFor="name"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Name
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.name && formik?.errors?.name}
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="consMobNum"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="consMobNum"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.consMobNum}
                        maxLength="11"
                      />
                      <label
                        htmlFor="consMobNum"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Mobile Number
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.consMobNum &&
                        formik?.errors?.consMobNum
                      }
                    />
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="MuiFormControl-root flex-1">
                    <div className="flex items-center">
                      <div className="relative flex-1">
                        <input
                          type="text"
                          id="address"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                          name="address"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.address}
                          maxLength={120}
                        />

                        <label
                          htmlFor="address"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Address
                        </label>
                      </div>
                      <div
                        className="MuiFormControl-root MuiTextField-root ml-1 cursor-pointer"
                        onClick={() => setShowMap("conAdd")}
                      >
                        <img
                          src="/location.svg"
                          alt=""
                          className="w-[30px] h-[30px] "
                        />
                      </div>
                    </div>
                    <ErrorText
                      text={formik?.touched?.address && formik?.errors?.address}
                    />
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="consEmail"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="consEmail"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.consEmail}
                      />
                      <label
                        htmlFor="consEmail"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Email
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.consEmail && formik?.errors?.consEmail
                      }
                    />
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="MuiFormControl-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="consLandMark"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        name="consLandMark"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.consLandMark}
                        maxLength={30}
                      />

                      <label
                        htmlFor="consLandMark"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Nearest Landmark
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.consLandMark &&
                        formik?.errors?.consLandMark
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center sm:mx-[auto]  flex-col gap-3 pt-[1rem] text-sm md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] rounded-md transition-all duration-500 mb-0">
            <div className="flex gap-4 md:w-[45rem]  w-[auto]">
              <div className="g-recaptcha">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_CAPTCH}
                  onChange={(value) => {
                    formik.setFieldValue("recaptcha", value);
                  }}
                />
              </div>
            </div>

            {/*  */}
            <button
              type="submit"
              onClick={() => {
                formik?.handleSubmit();
              }}
              className=" text-white bg-[#D40511] border border-[#F21E26] md:w-[45rem] sm:w-[40rem] w-[auto] mt-[1rem] rounded-md mb-6 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] transition-all duration-500"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      <div
        ref={modalRef}
        className={`${styles.modal__wrap}`}
        onClick={() => setShow(false)}
      >
        <div
          className={`flex flex-col justify-center items-center ${styles.modal}`}
        >
          <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
            <div className="flex justify-center items-center">
              <img
                src="/popup-circle.png"
                alt=""
                className="mx-auto w-[12.5rem]"
              />
              <img
                src="/popup-icon.png"
                alt=""
                className="absolute top-[-3.5rem] mx-auto w-[7rem]"
              />
            </div>
            <div className="absolute right-[1rem] top-[1rem] ">
              <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
            </div>
            <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
              <h2 className="font-bold text-xl">Thank you for submitting.</h2>
              <p>{`Your Pickup ID is ${responseID}.`}</p>
            </div>
          </div>
          <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
        </div>
      </div>
      {/* <ScheduleMapModal isShow={isShowMap} setShow={setShowMap} /> */}
      <div
        ref={modalMapRef}
        className={`${styles.modal__wrap}`}
        // onClick={() => setShowMap(false)}
      >
        <div
          className={`flex flex-col justify-center items-center ${styles.modal}`}
        >
          <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
            <div
              // className="flex flex-col text-center justify-center item-center mt-[6rem]"
              className="flex flex-col text-center justify-center item-center rounded-3xl overflow-hidden w-[100%] h-[100%]"
            >
              <LoadScript googleMapsApiKey="AIzaSyA60gAFM1MOpyBF30dymn-_F3sOanHcGGs">
                <GoogleMap
                  // mapContainerStyle={containerStyle}
                  mapContainerStyle={{
                    // border: "10px solid blue",
                    width: "100%",
                    // width: "100px",
                    height: "100%",
                  }}
                  center={position}
                  // position={position}
                  // zoom={zoom}
                  zoom={12}
                  onClick={(e) => {
                    setPosition({
                      lat: e.latLng.lat(),
                      lng: e.latLng.lng(),
                    });
                    // console.log(']]]]]]]]]]]]]]]]',geocoder)
                    // const res = await fetch(
                    //   // `http://maps.googleapis.com/maps/api/geocode/json?latlng=40.714224,-73.961452&sensor=true/false`
                    //   // `http://maps.googleapis.com/maps/api/geocode/json?latlng=${e.latLng.lat()},${e.latLng.lng()}&key=AIzaSyA60gAFM1MOpyBF30dymn-_F3sOanHcGGs`
                    //   `https://maps.googleapis.com/maps/api/geocode/json?latlng=40.714224,-73.961452&sensor=true&key=AIzaSyA60gAFM1MOpyBF30dymn-_F3sOanHcGGs`
                    // );
                    // console.log("res", res);
                  }}
                >
                  <>
                    <Marker
                      position={position}
                      // onPositionChanged={() => console.log("dsadsa")}
                    />
                  </>
                </GoogleMap>
              </LoadScript>

              <div className=" top-[0] rounded-3xl flex justify-center w-[100%]">
                <div className="flex justify-center items-center">
                  <img
                    src="/popup-circle.png"
                    alt=""
                    className="absolute top-[0] w-[12.5rem]"
                  />
                  <div className="bg-[red] absolute top-[-3.5rem] mx-auto w-[7rem] rounded-[50%] flex items-center justify-center">
                    <img src="/globalImg.png" alt="" className="w-[100%]" />
                  </div>
                </div>
              </div>

              <div className="address-input bg-[white] rounded absolute bottom-[2%] left-[10%] right-[10%] py-[2%] shadow-2xl">
                {/* <p className="text-sm mx-[2%]">{address}</p> */}
                <div
                  // style={{ border: "3px solid" }}
                  className="w-[100%] relative flex justify-center"
                >
                  {locationArr?.length > 0 && address && (
                    <div
                      // style={{ border: "3px solid green" }}
                      className="absolute bg-[white] bottom-[40px] left-[4%] right-[4%] rounded"
                    >
                      {locationArr?.map((each, index) => (
                        <p
                          key={index}
                          className="cursor-pointer hover:opacity-[0.5] m-[1%] text-left text-[12px]"
                          onClick={() => {
                            setAddress(each?.formatted_address);
                            setLocationArr([]);
                          }}
                        >
                          {each?.formatted_address}
                        </p>
                      ))}
                    </div>
                  )}
                  {/* <div className="flex"> */}
                  <div
                    onClick={() => setPosition(center)}
                    className="rounded-full border-2 border-black-100  w-[40px] h-[40px] flex items-center justify-center p-[1%] cursor-pointer"
                  >
                    <img
                      src="live-location.png"
                      alt=""
                      // width="30px"
                      // height="30px"
                    />
                  </div>
                  <input
                    type="text"
                    placeholder="Enter Your Address"
                    value={address}
                    className="w-[85%] mx-[1%] text-[12px] font-medium h-[40px] focus:outline-none focus:ring-0 focus:border-red-600 peer rounded-sm"
                    onChange={(e) => {
                      setAddress(e?.target?.value);
                      if (e?.target?.value) {
                        Geocode.setApiKey(apiKey);
                        Geocode.fromAddress(e?.target?.value)
                          .then((response) => {
                            const { lat, lng } =
                              response.results[0].geometry.location;
                            // console.log("response.results", response.results);
                            setLocationArr(response.results);
                            // const address = response.results[0].formatted_address;

                            // const newCenter = {
                            //   lat: lat,
                            //   lng: lng,
                            // };

                            setPosition({ lat, lng });
                            // setAddress(address);
                          })
                          .catch((error) => {
                            console.error(error);
                          });
                      }
                    }}
                  />
                </div>

                <div className="w-[100%] mx-[auto] mt-[2%] flex justify-around items-center">
                  <button
                    onClick={() => {
                      formik?.setFieldValue(
                        isShowMap === "shipAdd" ? "shipAddress" : "address",
                        address
                      );
                      setShowMap("");
                    }}
                    className="bg-[red] rounded-lg w-[45%] text-[white] mx-[auto] pb-[5px] py-[5px]"
                  >
                    Confirm Location
                  </button>
                  <button
                    onClick={() => {
                      setShowMap("");
                      setAddress("");
                    }}
                    className="bg-[red] rounded-lg w-[45%] text-[white] mx-[auto] pb-[5px] py-[5px]"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
        </div>
      </div>
    </div>
  );
};

export default PickupRequest;
